import axios from 'axios'

export default {
  getSliders ({ commit }) {
    axios.get('/sliders').then(response => {
      commit('SET_SLIDERS_ADMIN', response.data.result)
    })
  },
}
